import { Calendar, List, Users } from 'lucide-react';
import React from 'react';
import { useUnsafeTranslation } from '../../../../../i18next';
import {
  RailButton,
  SectionRailContainer
} from '../../../components/Builders/newux/kit/Shell';

export type ParticipantDialogSection =
  | 'TIMELINE_ITEMS'
  | 'ACTORS_AND_DATES'
  | 'EXPERIENCE_LOG';

export const IconSidebarNav: React.FC<{
  value: ParticipantDialogSection;
  onChange: (next: ParticipantDialogSection) => void;
}> = ({ value, onChange }) => {
  const { t } = useUnsafeTranslation();
  return (
    <SectionRailContainer>
      <RailButton
        active={value === 'TIMELINE_ITEMS'}
        title={t('Timeline items')}
        onClick={() => onChange('TIMELINE_ITEMS')}
      >
        <List size={18} />
      </RailButton>
      <RailButton
        active={value === 'ACTORS_AND_DATES'}
        title={t('Supporting actors and dates')}
        onClick={() => onChange('ACTORS_AND_DATES')}
      >
        <Users size={18} />
      </RailButton>
      <RailButton
        active={value === 'EXPERIENCE_LOG'}
        title={t('Experience log')}
        onClick={() => onChange('EXPERIENCE_LOG')}
      >
        <Calendar size={18} />
      </RailButton>
    </SectionRailContainer>
  );
};
